import { Model } from 'modules/core/lib/mobx-rest'

export type Status =
  | 'paid'
  | 'refunded'
  | 'payment_due'
  | 'refund_due'
  | 'not_paid'
  | 'adjusted'
  | 'posted'

export interface IInvoice {
  id: number
  number: number
  total: number
  date: number
  start_date: number | null
  end_date: number | null
  credit_note: boolean
  payment_link: string | null
  status: Status
}

class Invoice extends Model<IInvoice> {
  static urlRoot() {
    return '/billing/invoices'
  }
}

export default Invoice
